module.exports = __webpack_public_path__ + "static/media/search.fdb428a4.svg";